import { TaggedError } from "../tagged-error.js";
export class UnexpectedError extends TaggedError {
    constructor(message) {
        super("UnexpectedError", message);
    }
}
